import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// Constants
import {
    ACTION_CREATE,
    ACTION_DELETE,
    ACTION_UPDATE,
    DATA_EMPTY,
    DATA_FAILED,
    DATA_LOADED
} from "../../../../component/Constants";

// Types
import NewRelicType from "../../../../types/integration/IntegrationType";

// Utils
import { CSVLink } from "react-csv";
import * as dayjs from "dayjs";
import { findIntegrationValue } from "../../../../helpers/utils";
import ConditionalRender from "../../../../helpers/ConditionalRender";


function List(props: { loading: number, newRelic: NewRelicType[], refresh: Function, isAdmin: boolean }) {
    const [showCreate, setShowCreate] = useState<boolean>(false);

    function refresh() {
        props.refresh();
    }

    useEffect(() => {
        if (props.loading === DATA_LOADED) {
            /*@ts-ignore*/
            const showButton = props.isAdmin && (!props.newRelic.length || (!props.newRelic.find(relic => relic.name === 'newrelic.account')))
            setShowCreate(showButton)
        }
    }, [props.loading, props.isAdmin]);

    const data = [{
        url: findIntegrationValue('url', props.newRelic, 'newrelic'),
        account: findIntegrationValue('account', props.newRelic, 'newrelic'),
        dbmarurl: findIntegrationValue('dbmarlin.url', props.newRelic, 'newrelic'),
        enable: findIntegrationValue('enable', props.newRelic, 'newrelic')
    }]

    return (
        <div className="col h-100">
            <div className="card">
                <div className="card-header">
                    <i className="fak fa-new-relic fa-fw" aria-hidden="true"/>
                    New Relic
                    <span className="badge bg-info"
                          data-tip="Total New Relic integration count">{data[0].account ? 1 : 0}</span>
                    <i className="collapse-toggle" role="button" data-bs-toggle="collapse"
                       data-bs-target="#collapseNewRelic" aria-expanded="false" aria-controls="collapseNewRelic"/>
                </div>
                <div id="collapseNewRelic" className="card-body collapse show">

                    {props.loading === DATA_EMPTY ? (
                        <div className="w-100 text-center text-muted my-3">
                            <i className="fal fa-ban fa-fw fa-2x"/>
                            <p>
                                <button type="button" className="btn btn-link" onClick={refresh}>New relic not found -
                                    Click to Refresh
                                </button>
                            </p>
                        </div>
                    ) : (
                        props.loading === DATA_FAILED ? (
                            <div className="w-100 text-center text-muted my-3">
                                <i className="fal fa-ban fa-fw fa-2x text-danger"/>
                                <p>
                                    <button type="button" className="btn btn-link" onClick={refresh}>Failed to Retrieve
                                        New Relic - Click to Refresh
                                    </button>
                                </p>
                            </div>
                        ) : (
                            <React.Fragment>
                                <div className="row row-cols-1 row-cols-md-2 table-search">
                                    <div className="col col-md-12">
                                        {/* show create button if account filed which is required is not present */}
                                        <ConditionalRender if={showCreate}>
                                            <Link to="/admin/integrations/new-relic/create"
                                                  state={{ action: ACTION_CREATE, newRelic: props.newRelic }}
                                                  role="button" className="btn btn-sm btn-success">
                                                <i className="fal fa-plus-square fa-fw"/><span>Create</span>
                                            </Link>
                                        </ConditionalRender>

                                        <CSVLink role="button"
                                                 headers={[{ label: 'URL', key: 'url' },
                                                     { label: 'Account', key: 'account' },
                                                     { label: 'Api Key', key: 'apikey' },
                                                     { label: 'DBmarlin URl', key: 'dbmarurl' },
                                                     { label: 'Enabled', key: 'enable' }]}
                                                 data={data}
                                                 download={`DBmarlin - ${dayjs.default().format('YYYY-MM-DD HH:mm')} - New Relic.csv`}
                                                 className="btn btn-sm btn-primary">
                                            <i className="fal fa-file-export fa-fw"/><span>Export</span>
                                        </CSVLink>
                                    </div>
                                </div>
                                <div className="table-responsive">
                                    <table className="table">
                                        <thead>
                                        <tr>
                                            <th scope="col">Url</th>
                                            <th scope="col">Account</th>
                                            <th scope="col">DBmarlin Url</th>
                                            <th scope="col">Enabled</th>
                                            <th className="actions" scope="col">Actions</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {data[0].url && data.map((item, index) => (
                                            <tr key={index}>
                                                <th scope="row">
                                                    {item.url}
                                                </th>
                                                <td className="concatenate">
                                                    {item.account}
                                                </td>
                                                <td className="concatenate">
                                                    {item.dbmarurl}
                                                </td>
                                                <td className="concatenate">
                                                    <div className='form-check form-switch'>
                                                        <input checked={item.enable}
                                                               type="checkbox"
                                                               id="enabled"
                                                               className="form-check-input"
                                                               disabled={true}
                                                               data-lpignore={true}
                                                        />
                                                    </div>
                                                </td>
                                                <td className="actions">
                                                    {props.isAdmin && (
                                                        <>
                                                            <Link to="/admin/integrations/new-relic/edit"
                                                                  state={{ action: ACTION_UPDATE, data }} role="button"
                                                                  className="btn btn-sm btn-primary">
                                                                <i className="fal fa-edit fa-fw"/><span>Edit</span>
                                                            </Link>
                                                            <Link to="/admin/integrations/new-relic/delete"
                                                                  state={{ action: ACTION_DELETE, data }} role="button"
                                                                  className="btn btn-sm btn-danger">
                                                                <i className="fal fa-trash-alt fa-fw"/><span>Delete</span>
                                                            </Link>
                                                        </>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            </React.Fragment>
                        )
                    )}
                </div>
            </div>
        </div>
    )
}

List.propTypes = {
    refresh: PropTypes.func.isRequired,
};

export default List;
